
import AnswerDropdown from './AnswerDropdown';
import Loading from '../../../../Loading/Loading';
import Show from '../../../../Show/Show';
import { AnswerSelectPresentationProps } from '../../config';
import { FC} from 'react';
import { ScrollView } from 'react-native';
import { TouchableText } from '../../../../TouchableText/TouchableText';
import { View } from 'react-native';
import { cast } from 'mobx-state-tree';
import { observer } from 'mobx-react';
import { useStores } from '../../../../../hooks/useStores';

const _PresentDropdown : FC<AnswerSelectPresentationProps> = ({
  answers: allAnswers,
  initSelected,
  onPress,
  labels,
  questionId
}) => {
  const {question: qstore} = useStores();
  const answers = allAnswers
    ?.filter(answer => answer.key !== 'fail') || [];
  const failAnswer = allAnswers
    ?.find(a => a.key === 'fail');

  return (
    <View style={{ justifyContent: 'center' }}>
      <ScrollView
        contentContainerStyle={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          marginBottom: 10,
          justifyContent: 'center'
        }}
        showsVerticalScrollIndicator={false}
      >
        <Show when={qstore.isReady(questionId)} fallback={<Loading />}>
          <AnswerDropdown
            answers={answers}
            onPress={onPress}
            search={false}
            flag={true}
            initSelection={initSelected ? cast(initSelected) : null}
            label={labels?.DROPDOWN}
          />
          <Show when={failAnswer} keyed>
            {answer => (
              <TouchableText
                onPress={() => onPress(answer)}
                label={answer?.wording || ''}
              />
            )}
          </Show>
        </Show>
      </ScrollView>
    </View>
  );
};

export const PresentDropdown = observer(_PresentDropdown);

